module.exports = __webpack_public_path__ + "img/vla_tips_logo_mini.508ff38a.png";